import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LeadTypeService } from '../../../../shared/services/leadType/lead.type.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-type-selection-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TypeSelectionDropdownComponent extends DropdownBaseComponent implements OnInit {

  @Input() loadOnInit = true;

  itemsLoaded = false;

  constructor(private readonly dropdownService: DropDownService,
              private readonly leadTypeService: LeadTypeService,
              private readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);

    if (true === this.loadOnInit) {
      this.loadLeadTypes();
    }

  }

  loadLeadTypes() {

    if (true === this.itemsLoaded) {
      return;
    }

    this.leadTypeService.leadTypeQuery$().subscribe(res => {
      this.itemsData = res.leadTypeList.map(leadType => new Object({
        id: leadType.name,
        name: this.translatorService.trans(`pages.leads.type.${leadType.name}`)
      }));

      this.itemsLoaded = true;
    });
  }
}
